import Types from "./Types";

export const getAllBucketsRequest = (body) => ({
  type: Types.GET_SUPERADMIN_BUCKETS_REQUEST,
  payload: body,
});

export const getAllBucketsSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_BUCKETS_SUCCESS,
  payload: data,
});

export const getAllBucketsFail = () => ({
  type: Types.GET_SUPERADMIN_BUCKETS_FAIL,
});

export const editBucketRequest = (formData) => ({
  type: Types.EDIT_SUPERADMIN_BUCKET_REQUEST,
  payload: formData,
});

export const editBucketSuccess = (data) => ({
  type: Types.EDIT_SUPERADMIN_BUCKET_SUCCESS,
  payload: data,
});

export const editBucketFail = () => ({
  type: Types.EDIT_SUPERADMIN_BUCKET_FAIL,
});

//LOADING
export const addBucketLoading = (isLoading) => ({
  type: Types.ADD_SUPERADMIN_BUCKETS_LOADING,
  payload: isLoading,
});

// Create Bucket
export const createBucketRequest = (formData, action) => ({
  type: Types.CREATE_SUPERADMIN_BUCKET_REQUEST,
  payload: formData,
  action: action,
});

export const createBucketSuccess = ({ data }) => ({
  type: Types.CREATE_SUPERADMIN_BUCKET_SUCCESS,
  payload: {
    data,
  },
});

export const createBucketFail = () => ({
  type: Types.CREATE_SUPERADMIN_BUCKET_FAIL,
});

export const deleteBucketRequest = (id) => ({
  type: Types.DELETE_SUPERADMIN_BUCKET_REQUEST,
  payload: id,
});

export const deleteBucketSuccess = (id) => ({
  type: Types.DELETE_SUPERADMIN_BUCKET_SUCCESS,
  payload: id,
});

export const deleteBucketFail = () => ({
  type: Types.DELETE_SUPERADMIN_BUCKET_FAIL,
});

export const enableBucketRequest = (formData) => ({
  type: Types.ENABLE_SUPERADMIN_BUCKET_REQUEST,
  payload: formData,
});

export const enableBucketSuccess = (data) => ({
  type: Types.ENABLE_SUPERADMIN_BUCKET_SUCCESS,
  payload: data,
});

export const enableBucketFail = () => ({
  type: Types.ENABLE_SUPERADMIN_BUCKET_FAIL,
});

export const restrictBucketRequest = (id) => ({
  type: Types.RESTRICT_SUPERADMIN_BUCKET_REQUEST,
  payload: id,
});

export const restrictBucketSuccess = (payload, result) => ({
  type: Types.RESTRICT_SUPERADMIN_BUCKET_SUCCESS,
  payload: { payload, result },
});

export const restrictBucketFail = () => ({
  type: Types.RESTRICT_SUPERADMIN_BUCKET_FAIL,
});
